<template>
  <b-card>

    <table-component
      :section="'userGroup'"
      :detail-url="'userGroupDetail'"
      :columns="columns"
      :show-status-actions="false"
    />

  </b-card>
</template>

<script>
import TableComponent from '@/layouts/components/TableComponent.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    TableComponent,
    BCard,
  },
  data() {
    return {
      columns: [
        {
          label: '#',
          field: 'id',
          type: 'number',
          tdClass: 'text-center',
          thClass: 'text-center',
          width: '50px',
        },
        {
          label: 'Group Name',
          field: 'groupName',
        },
      ],
    }
  },
}
</script>
